module.exports = __webpack_public_path__ + "static/media/gift-1.ae45fa90.png";